import { IconButton, Tooltip } from '@mui/material'

import AddBusinessIcon from '@mui/icons-material/AddBusiness'
import EditIcon from '@mui/icons-material/Edit'

import { useNavigate, Link } from 'react-router-dom'
import InfiniteList from '../../ui/InfiniteList'
import DealershipView from './DealershipView'
import dealershipBrandsDict from '../../../constants/dealershipBrands'
import { useGetDealershipsInfinite } from '../../../hooks/api/dealerships'

const headCells = (props) => [
  {
    id: '_id',
    numeric: false,
    sortable: false,
    disablePadding: false,
    label: 'ID',
  },
  {
    id: 'name',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'brand',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Brand',
    view: (data) => data.brand && (dealershipBrandsDict[data.brand] || data.brand),
  },
  {
    id: 'registration',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Registration',
    view: (data) =>
      data.registration
        ? `${data.registration}${data.registrationLegacy ? ` (${data.registrationLegacy})` : ''}`
        : data.registrationLegacy,
  },
  {
    id: 'edit',
    numeric: true,
    sortable: false,
    disablePadding: false,
    label: '',
    view: (data) => (
      <Tooltip title='Edit'>
        <IconButton LinkComponent={Link} to={`/admin/dealerships/edit/${data.id}`}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    ),
  },
]

export function DealershipsTable() {
  const navigate = useNavigate()

  const handleNew = () => {
    navigate('/admin/dealerships/create')
  }

  return (
    <InfiniteList
      component={DealershipView}
      useInfiniteQuery={useGetDealershipsInfinite}
      headCells={headCells()}
      onNew={handleNew}
      orderByKey='name'
      newIcon={<AddBusinessIcon />}
      newLabel='New dealership'
      expand
    />
  )
}
